import { cva as t } from "class-variance-authority";
var i = t("lib:font-cygre", {
  variants: {
    size: {
      hero: "lib:font-aqum2 lib:font-black lib:text-hero-sm lib:tracking-wider lib:md:text-hero-md lib:xl:text-hero-xl",
      grand: "lib:font-aqum2 lib:font-black lib:text-grand-sm lib:tracking-widest lib:md:text-grand-md lib:xl:text-grand-xl",
      h1: "lib:text-h1-sm lib:tracking-wider lib:md:text-h1-md lib:xl:text-h1-xl",
      h2: "lib:text-h2-sm lib:md:text-h2-md lib:xl:text-h2-xl",
      h3: "lib:text-h3-sm lib:md:text-h3-md lib:xl:text-h3-xl",
      h4: "lib:text-h4-sm lib:md:text-h4-md lib:xl:text-h4-xl",
      h5: "lib:text-h5-sm lib:md:text-h5-md lib:xl:text-h5-xl"
    },
    color: {
      current: "lib:text-current",
      dark: "lib:text-dark-90",
      white: "lib:text-white"
    },
    fontFamily: {
      none: null,
      cygre: "lib:font-cygre",
      aqum2: "lib:font-aqum2"
    },
    weight: {
      regular: "lib:font-normal",
      semibold: "lib:font-semibold",
      bold: "lib:font-bold"
    },
    align: {
      left: "lib:text-left",
      center: "lib:text-center",
      right: "lib:text-right",
      justify: "lib:text-justify"
    }
  },
  defaultVariants: {
    size: "h2",
    color: "dark",
    weight: "bold",
    align: "left",
    fontFamily: "none"
  }
});
export {
  i as headingVariants
};
